import React from "react";
import BackgroundImage from "../Images/Black_Smiley_Face.jpg";
import GoldloxeFeet from "../Images/Goldloxe_forfeet.png";

export default function TeamContact() {
    return <div className="Section sThree" style={{ backgroundImage: `url(${BackgroundImage})` }}>
                <div className="goldloxe-forfeet-container" style={{ backgroundImage: `url(${GoldloxeFeet})` }}></div>
                <div className="sectionText">
                <h3>Just Right! by Goldloxe is rooted in rave culture, plant medicine and self-expression. Anti-greed. Pro-love. A small reminder that being here at all is the lucky bit. </h3>
                <br/>
                <h3>Say hello: Justrightlandy@gmail.com </h3>
                </div>
            </div>
}